export default "/assets/images/mila-feed-02.mp4?1e7f3f08c0f90241bb79729bd180b6b8";